module.exports = __webpack_public_path__ + "static/media/YM33_1.79c38aa1.jpg";